'use client';

import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from '@posthog/react';
import type { ReactNode } from 'react';
import { env } from '@/config/env';

interface PostHogProviderProps {
  children: ReactNode;
}

/**
 * PostHog React context provider.
 *
 * PostHog is initialized in instrumentation-client.ts using the modern
 * Next.js 15.3+ approach. This provider makes the PostHog client available
 * via React context for hooks like usePostHog, useFeatureFlagEnabled, etc.
 *
 * Only renders when PostHog is configured to prevent runtime errors.
 *
 * @see https://posthog.com/docs/libraries/next-js
 */
export function PostHogProvider({ children }: PostHogProviderProps) {
  // Only render provider if PostHog is configured
  if (!env.NEXT_PUBLIC_POSTHOG_KEY) {
    return <>{children}</>;
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
